module.exports = __webpack_public_path__ + "img/news10.a4bba7cb.png";